import React from 'react';
import SuccessModal from '../common/SuccessModal';
import IconSent from '../../assets/icons/ic-sent.svg';

interface EmailSentModalProps {
  open: boolean;
  onClose: () => void;
}

const EmailSentModal: React.FC<EmailSentModalProps> = ({ open, onClose }) => {
  return (
    <SuccessModal
      open={open}
      onClose={onClose}
      icon={IconSent}
      title="Email sent"
      description={
        <>
          We've sent a one-time code to your email. Please check your inbox (and spam folder, just in case) and enter the code to continue.
        </>
      }
    />
  );
};

export default EmailSentModal;
